import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMaintenanceMode: false,
};

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action) => {
      if (typeof action.payload === 'boolean') {
        return {
          ...state,
          isMaintenanceMode: action.payload,
        };
      }

      return state;
    },
  },
});

export const { setMaintenanceMode } = appStateSlice.actions;

export const selectIsMaintenanceMode = (state) => state.appState?.isMaintenanceMode;

export default appStateSlice.reducer;
